import { render, staticRenderFns } from "./ZonaAmortecimentoTerraIndigena.vue?vue&type=template&id=249efbd8&lang=pug"
import script from "./ZonaAmortecimentoTerraIndigena.vue?vue&type=script&lang=js"
export * from "./ZonaAmortecimentoTerraIndigena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports